module.exports = __webpack_public_path__ + "static/media/routes02.7515dc6f.webp";